export default "__VITE_ASSET__Cv80Q0EC__"